// extracted by mini-css-extract-plugin
module.exports = {"shippingName":"DeliveryWindow_shippingName__EZ7Va","shippingDates":"DeliveryWindow_shippingDates__grTiT"};